import React from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faFilePdf,
  faCalendar,
} from "@fortawesome/free-solid-svg-icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import SearchDateBox from "../../SearchDateBoxOnly";
import { Modal, Button } from "react-bootstrap";

import { Chart as ChartJS } from "chart.js/auto";
import { Doughnut } from "react-chartjs-2";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import ChartExpandModal from "../../../services/utilities/ChartExpandModal";
import { connect } from "react-redux";

function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class OwnershipShare extends React.Component {
  static contextType = FilterContext;

  constructor(props) {
    super(props);
    this.state = {
      expandChartKey: Math.random(),
      expandChart: false,
      showLoader: false,
      showGraph: false,
      filters: "",
      isOpen: false,
      start_date: "",
      end_date: "",
      chartOtions: {},
      chartData: {
        labels: [],
        datasets: [],
      },
    };
  }

  componentDidMount() {
    this.setState({ showLoader: true, showGraph: false });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    const options = {
      responsive: true,
      type: "doughnut",
      radius: "80%",
      animation: { animateRotate: false, animateScale: true },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "rgb(0, 0, 0)",
            boxWidth: 6,
            boxHeight: 6,
            usePointStyle: true,
          },
        },
        title: {
          display: false,
        },
        datalabels: {
          color: "white",
          // display: function (ctx) {
          //   return ctx.dataset.data[ctx.dataIndex] > 35000000;
          // },
          // formatter: function (value) {
          //   return Math.round(value / 1000000, 2) + "mn";
          // },
          font: {
            weight: "bold",
          },
          offset: 0,
          padding: 0,
        },
      },
      scales: {
        x: {
          ticks: {
            display: false,
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
        y: {
          ticks: {
            display: false,
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
      },
    };

    apiMiddleware
      .post(
        "api/edge/office/get_owner_ownership_share",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ showLoader: false, showGraph: true });
        const data = {
          labels: res.data.x,
          datasets: [
            {
              data: res.data.y,
              backgroundColor: res.data.bgcolor,
              hoverOffset: 4,
            },
          ],
        };

        this.setState({
          chartOtions: options,
          chartData: data,
        });
      });
  }
  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });
      this.setState({ showLoader: true, showGraph: false });

      const options = {
        responsive: true,
        type: "doughnut",
        radius: "80%",
        animation: { animateRotate: false, animateScale: true },
        plugins: {
          legend: {
            display: true,
            labels: {
              color: "rgb(0, 0, 0)",
              boxWidth: 6,
              boxHeight: 6,
              usePointStyle: true,
            },
          },
          title: {
            display: false,
          },
          datalabels: {
            color: "white",
            // display: function (ctx) {
            //   return ctx.dataset.data[ctx.dataIndex] > 35000000;
            // },
            // formatter: function (value) {
            //   return Math.round(value / 1000000, 2) + "mn";
            // },
            font: {
              weight: "bold",
            },
            offset: 0,
            padding: 0,
          },
        },
        scales: {
          x: {
            ticks: {
              display: false,
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            ticks: {
              display: false,
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
        },
      };
      var body = new FormData();
      body.append("filter", JSON.stringify(this.props.filters));
      if (
        this.state.end_date.length > 0 &&
        this.state.end_date != "ull" &&
        this.state.start_date.length > 0 &&
        this.state.start_date != "ull"
      ) {
        body.append("end_date", this.state.end_date);
        body.append("start_date", this.state.start_date);
      }

      apiMiddleware
        .post("api/edge/office/get_owner_ownership_share", body)
        .then((res) => {
          this.setState({ showLoader: false, showGraph: true });
          const data = {
            labels: res.data.x,
            datasets: [
              {
                data: res.data.y,
                backgroundColor: res.data.bgcolor,
                hoverOffset: 4,
              },
            ],
          };

          this.setState({
            chartOtions: options,
            chartData: data,
          });
        });
    }
  }
  downloadPdf() {
    const input = document.getElementById("ownershipShare");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 0, 0);
      pdf.save("ownershipShare.pdf");
    });
  }
  dateFilter = (dateValue) => {
    this.setState({
      start_date: dateValue.startDate,
      end_date: dateValue.endDate,
      filters: "",
      isOpen: false,
    });
  };
  openModal = () => {
    this.setState({ isOpen: true });
  };
  closeModal = () => this.setState({ isOpen: false });

  render() {
    const data = {};
    data.startDate = this.state.start_date;
    data.endDate = this.state.end_date;
    return (
      <div className="widget widgetGraph" id="ownershipShare">
        {this.state.showLoader && (
          <div className="row">
            <div className="col-lg-12 text-center">
              <img src="/edge/images/edgeLoader.gif" />
            </div>
          </div>
        )}
        {this.state.showGraph && (
          <div className="row">
            <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
              <p>Ownership Share</p>
              {this.state.start_date.length > 0 &&
                this.state.end_date.length > 0 &&
                this.state.start_date != "ull" && (
                  <p className="dateFont">
                    {this.state.start_date} To {this.state.end_date}
                  </p>
                )}
            </div>
            <div className="col-lg-3 text-end">
              {/* <p className="colorBlack downloads me-2">
              <FontAwesomeIcon
                icon={faCalendar}
                className="dateOptions"
                onClick={(e) => {
                  this.openModal();
                  // this.opendatePopup();
                }}
              />
            </p> */}
              <p className="colorBlack downloads">
                <FontAwesomeIcon icon={faEllipsisV} />
                <ul className="downloadOptions">
                  <li
                    className="pdfDownload"
                    onClick={(e) => {
                      this.downloadPdf();
                    }}
                  >
                    <FontAwesomeIcon icon={faFilePdf} /> Download as PDF
                  </li>
                  <li
                    className="pdfDownload"
                    onClick={(e) => {
                      this.openModal();
                    }}
                  >
                    Select Date Range
                  </li>
                  <li
                    className="pdfDownload"
                    onClick={(e) => {
                      this.setState({
                        expandChart: true,
                        expandChartKey: Math.random(),
                      });
                    }}
                  >
                    Expand Chart
                  </li>
                </ul>
              </p>
            </div>
            <div className="col-lg-12">
              <Doughnut
                options={this.state.chartOtions}
                data={this.state.chartData}
                // plugins={[ChartDataLabels]}
              />
            </div>
            <div className="row">
              <div className="col-lg-12 chartSearchBox">
                <Modal
                  show={this.state.isOpen}
                  onHide={this.closeModal}
                  className="columnsModal selectColumn downloadImgModal chartModal"
                  size="lg"
                >
                  <Modal.Body>
                    <SearchDateBox
                      datechildFilter={this.dateFilter}
                      parentData={data}
                    />
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </div>
        )}
        <ChartExpandModal
          openModal={this.state.expandChart}
          chartName={OwnershipShare}
          key={this.state.expandChartKey}
          filters={this.state.filters}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(OwnershipShare);
